import styled from 'styled-components';

export const Container = styled.div`
  margin: 2rem 0;
  position: relative;
  width: 100%;
  min-height: 500px;
  max-width: 800px;
  margin: 0 auto;

  p{
    font-weight: bold;
    margin: 12px 0;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc((50% - var(--line-size)) + var(--line-size) / 2);
    border-left: var(--line-size) solid var(--color-gray);
  }

  .timeline-left,
  .timeline-right {
    margin-top: 1rem;
    padding-top: 1.9rem;
    position: relative;
    display: flex;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0rem;
      width: var(--line-circle-size);
      height: var(--line-circle-size);
      border-radius: 20rem;
      border: var(--line-circle-border-size) solid var(--color-gray);
      background: #ffffff;
      z-index: 10;
    }
  }
  .timeline-left {
    padding-right: calc(
      var(--card-margin) + var(--line-size) * 2
    );
    width: calc((50% - var(--line-size)) + var(--line-size) / 2);
    justify-content: end;

    &::before {
      right: calc(
        -0.5rem - var(--line-circle-border-size) - (var(--line-size) / 2)
      );
    }
  }

  .timeline-right {
    padding-left: calc(
      var(--card-margin) + var(--line-size) * 2
    ); // Untuk mengatur jarak card dari garis

    margin-left: calc(50% + var(--line-size) - (var(--line-size) / 2));
    width: calc(50% - var(--line-size) + (var(--line-size) / 2));

    &::before {
      left: calc(
        -0.5rem - var(--line-circle-border-size) - (var(--line-size) / 2)
      );
    }
  }

  .card {
    position: relative;
    padding: 1rem;
    border: 1px solid var(--color-yellow-dark);
    border-radius: 0.5rem;
    background: var(--color-yellow);
    color: var(--color-black);
    width: 100%;
    max-width: var(--card-max-width);
    z-index: 20;

    &.left,
    &.right {
      &::before {
        content: '';
        position: absolute;
        top: calc(50% - var(--card-arrow-size));
        display: block;
        border: var(--card-arrow-size) solid var(--color-yellow);
        border-top-color: transparent;
        border-bottom-color: transparent;
      }
    }
    &.left::before {
      right: -2rem;
      border-right-color: transparent;
    }
    &.right::before {
      left: -2rem;
      border-left-color: transparent;
    }
  }
`;